import React from "react";
import { cn, initials } from "@/lib/utils";

const sizeClass = {
    sm: "h-6 w-6 text-[10px]",
    md: "h-9 w-9 text-xs",
    lg: "h-12 w-12 text-sm",
    xl: "h-16 w-16 text-base",
};

export const NxAvatar = ({ name = "", src, size = "md", className = "", testId }) => {
    return (
        <div
            data-testid={testId}
            className={cn(
                "rounded-full overflow-hidden border border-[color:var(--glass-border)] shadow-sm flex-shrink-0",
                sizeClass[size] || sizeClass.md,
                className,
            )}
        >
            {src ? (
                <img src={src} alt={name} className="h-full w-full object-cover" />
            ) : (
                <div className={cn("avatar-fallback h-full w-full")}>{initials(name)}</div>
            )}
        </div>
    );
};
